import { SearchBaseModel } from '../commonModels';
import { DateRange } from '../commonModels';
import { OrderSearchModel } from '../order/orderSearch';

export class TyreReturnOrderSearchModel extends OrderSearchModel {

  constructor() {
    super();

    this.ExludedOrderStatusId = new Array();

  }

  public ExludedOrderStatusId: number[];
}

